import styled from "styled-components"

import { maxWidth, minWidth } from "utils"

import CloudinaryImage from "components/cloudinary-image"
import { Link } from "gatsby"

export const Wrapper = styled.div`
  width: 100%;
  max-width: 80rem;
  margin: 0 auto 8rem;
  display: flex;
  justify-content: center;
`
export const WrapperDesktop = styled(Wrapper)`
  ${maxWidth.hamburgerLarge`
    display: none;
  `}
`
export const WrapperHamburgerLarge = styled(Wrapper)`
  flex-direction: column;
  max-width: 68rem;
  ${minWidth.hamburgerLarge`
    display: none;
  `}
`

export const InnerWrapper = styled.div`
  width: 100%;
  min-width: 22rem;
  max-width: 28rem;
  padding: 3.5rem 3.2rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  background-color: ${({ hasspecialid }) => (hasspecialid === "true" ? "#164036" : "#6674a2")};
  opacity: ${({ hasspecialid }) => (hasspecialid === "true" ? 0.9 : 1)};

  ${maxWidth.hamburgerLarge`
    max-width: 100%;
    flex-direction: row;
  `}

  ${maxWidth.tablet`
    justify-content: flex-start;
  `}
`

export const ImageWrapper = styled.div`
  width: 14rem;
  height: 14rem;
  margin: 0 auto 1.5rem;
  border-radius: 50%;
  background: linear-gradient(to bottom, #2d7b9e, #3ec6c2);
  background-image: linear-gradient(rgb(45, 123, 158), rgb(62, 198, 194));
  background-position-x: initial;
  background-position-y: initial;
  background-size: initial;
  background-repeat-x: initial;
  background-repeat-y: initial;
  background-attachment: initial;
  background-origin: initial;
  background-clip: initial;
  background-color: initial;

  ${maxWidth.hamburgerLarge`
    width: 10rem;
    height: 10rem;
    margin: 0 2rem 0 0;
  `}
`

export const Image = styled(CloudinaryImage)`
  width: 14rem;
  height: 14rem;
  margin: 0 auto;
  border-radius: 50%;

  ${maxWidth.hamburgerLarge`
    width: 10rem;
    height: 10rem;
    margin: 0 1.5rem 0 0;
  `}
`

export const TextContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;

  ${maxWidth.hamburgerLarge`
    max-width: 75%;
  `}
`

export const Name = styled.div`
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 2.3rem;
  font-weight: 700;
  line-height: 1.3;
  color: #fff;
`

export const Biography = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 1.8rem;
  line-height: 1.3;
  color: #fff;

  ${maxWidth.hamburgerLarge`
      -webkit-line-clamp: 2;
    `}

  ${maxWidth.tablet`
      display: none;
    `}
`

export const ReadMoreText = styled.a`
  font-size: 1.4rem;
  font-style: italic;
  line-height: 1.3;
  color: #fff;
  padding-top: 1rem;
`

export const MoreContainer = styled.div`
  width: 100%;
  padding: 3.5rem 3.9rem 1.3rem 2.8rem;
  background-color: ${({ hasspecialid }) => (hasspecialid === "true" ? "#164036" : "#526199")};

  ${maxWidth.hamburgerLarge`
    padding: 3.5rem 3.9rem 3.5rem 5.5rem;
  `}

  ${maxWidth.tablet`
    padding: 3rem 3.5rem 3.5rem 3.2rem;
  `}
`

export const HeadContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${maxWidth.tablet`
    align-items: flex-start;
    flex-direction: column;
  `}
`

export const TextMore = styled.p`
  margin: 0;
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: 2.1px;
  text-transform: uppercase;
  color: #fff;

  ${maxWidth.hamburgerLarge`
    font-size: 1.4rem;
  `}

  ${maxWidth.tablet`
    font-size: 1.2rem;
  `}
`

export const Logo = styled.div`
  font-family: Monoline, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 2rem;
  color: #fff;

  ::before {
    content: "Mbg";
  }

  ::after {
    content: "Classes";
  }

  ${maxWidth.tablet`
    margin-top: 1rem;
  `}
`

export const Title = styled.p`
  margin: 1rem 0;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 3.6rem;
  font-weight: 500;
  line-height: 1.2;
  color: #fff;

  ${maxWidth.hamburgerLarge`
    font-size: 2.4rem;
  `}

  ${maxWidth.tablet`
    font-size: 2rem;
  `}
`

export const CheckOutText = styled.div`
  display: flex;
  font-size: 2rem;
  line-height: 1.3;
  color: #fff;

  p {
    margin: 0;
    font-style: italic;

    span {
      font-weight: 500;
    }
  }

  ${maxWidth.hamburgerLarge`
    font-size: 1.6rem;
  `}

  ${maxWidth.tablet`
    font-size: 1.4rem;
  `}
`

export const EditorialDescription = styled.p`
  margin: 0;
  padding: 1.5rem 0;
  display: flex;
  font-size: 1.8rem;
  line-height: 1.3;
  color: #fff;

  ${maxWidth.hamburgerLarge`
    font-size: 1.6rem;
  `}

  ${maxWidth.tablet`
    font-size: 1.6rem;
  `}
`

export const LearnMore = styled(Link)`
  position: relative;
  display: block;
  text-align: center;
  width: 75%;
  margin-top: 1.5rem;
  padding: 1.1rem 3.5rem;
  border: 2px solid #fff;
  border-radius: 2.8rem;
  font-size: 1.6rem;
  letter-spacing: 0.2rem;
  text-transform: uppercase;
  background: ${({ hasspecialid }) => (hasspecialid === "true" ? "#164036" : "#526199")};
  color: #fff;
  transition: background-color 0.5s;
  cursor: pointer;

  :hover {
    background-color: #fff;
    color: ${({ hasspecialid }) => (hasspecialid === "true" ? "#164036" : "#526199")};
  }

  ${maxWidth.tablet`
    width: 100%;
  `}
`
